import axios from 'axios';
import { getSessionCookie, setSessionCookie } from '../helpers/cookies';
const api = axios.create({
    baseURL: process.env.REACT_APP_API_ENDPOINT,
})

const tenantId = window.location.host.split(':')[0].split('.')[0];

// A validação automática do [ApiController] devolve `errors` e não `message`.
const getErrorMessage = (data) => {
    if (data.message || !data.errors)
        return data.message;
    return [...new Set(Object.values(data.errors).flat())].join("\n");
}

const request = async (endpoint, obj, method, contentType) => {

    const promise = new Promise((resolve, reject) => {

        const session = getSessionCookie();

        if (!!session?.token) {
            const now = new Date();
            if (!session || (new Date(session.expiration)) < now) {
                setSessionCookie(null);
                window.location.reload();
                resolve(null);
            }
        }

        const success = (result => {
            var newResult = {
                status: result.status,
                message: result.message,
                data: result.data
            }

            resolve(newResult);
        });

        const failed = (error => {
            if (error.response) {
                if (error.response.status === 401 || error.response.status === 403)
                    reject({ status: error.response.status, message: "Sua sessão expirou. Realize o acesso novamente" });
                else
                    try {
                        reject({ status: error.response.data.status, message: error.response.data ? getErrorMessage(error.response.data) : error.response.message });
                    }
                    catch {
                        reject({ status: 500, message: "Erro ao conectar com API" });
                    }
            }
            else {
                reject({ status: 500, message: "Erro ao conectar com API" });
            }
        })

        const headers = () => {
            const _headers = {
                headers: {
                    'tenantId': tenantId,
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                }
            };

            if (!!session?.token)
                _headers.headers.Authorization = `Bearer ${session.token}`

            if (session && session.acesso && (session.acesso.sigla == "TR" || session.acesso.sigla == "GS" || session.acesso.sigla == "GG" || session.acesso.sigla == "DS"))
                _headers.headers[session.acesso.modulo] = session.acesso.acesso_id;

            if (contentType === "multipart/form-data") {
                delete _headers.headers['Content-Type'];
            } else {
                _headers.headers['Content-Type'] = contentType;
            }

            return _headers;
        }

        try {
            if (method === "POST")
                return api.post(endpoint, obj, headers())
                    .then(result => success(result))
                    .catch(error => failed(error));
            else if (method === "PUT")
                return api.put(endpoint, obj, headers())
                    .then(result => success(result))
                    .catch(error => failed(error));
            else if (method === "GET")
                return api.get(endpoint, headers())
                    .then(result => success(result))
                    .catch(error => failed(error));
            else if (method === "DELETE")
                return api.delete(endpoint, headers())
                    .then(result => success(result))
                    .catch(error => failed(error));

        }
        catch (error) {
            var result = {
                status: 500,
                message: "Erro no servidor (500)"
            }
            resolve(result);
        }
    });

    return promise;
};

const api_POST = async (endpoint, obj, contentType) => {
    let _contentType = contentType;
    if (!contentType)
        _contentType = 'application/json';
    return request(endpoint, obj, "POST", _contentType);
};

const api_POST_files = async (endpoint, obj) => {
    return request(endpoint, obj, "POST", "multipart/form-data");
};

const api_POST_files_Unauthorize = async (endpoint, obj) => {
    return request(endpoint, obj, "POST", "multipart/form-data");
};

const api_PUT = async (endpoint, obj) => {
    return request(endpoint, obj, "PUT", 'application/json');
};

const api_DELETE = async (endpoint, obj) => {
    return request(endpoint, obj, "DELETE", 'application/json');
};

const api_GET = async (endpoint) => {
    return request(endpoint, null, "GET", 'application/json');
};

const api_GET_Unauthorize = async (endpoint) => {
    return request(endpoint, null, "GET", 'application/json');
};

const api_POST_Unauthorize = (endpoint, obj) => {
    return request(endpoint, obj, "POST", 'application/json');
}

const api_GET_External = (endpoint) => {

    const promise = new Promise((resolve, reject) => {

        try {
            return axios.get(endpoint)
                .then(result => {
                    let newResult = {
                        status: result.status,
                        data: result.data,
                        headers: result.headers
                    }
                    resolve(newResult);
                })
                .catch(function (error) {
                    if (error.response) {
                        if (error.response.status === 401 || error.response.status === 403) {
                            reject({ status: error.response.status, message: "Sua sessão expirou. Realize o acesso novamente" });
                        }
                        else {
                            try {
                                reject({ status: error.response.data.status, message: error.response.data ? error.response.data.message : error.response.message });
                            }
                            catch {
                                reject({ status: 500, message: "Erro ao conectar com API" });
                            }
                        }
                    }
                    else {
                        reject({ status: 500, message: "Erro ao conectar com API" });
                    }
                });

        } catch (error) {
            let result = {
                status: 500,
                message: "Erro no servidor."
            }
            reject(result);
        }

    });

    return promise;

};

export { api_POST, api_POST_Unauthorize, api_PUT, api_DELETE, api_GET, api_GET_External, api_GET_Unauthorize, api_POST_files, api_POST_files_Unauthorize };